"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = zIndexStack;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _getDisplayName = _interopRequireDefault(require("../utils/get-display-name"));

function _createSuper(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

var ZIndexStackContext = (0, _react.createContext)({});
/**
 * Функция, задающая контекс zIndex
 * 1. Достаем значение zIndex в стеке
 * 2. Прибавляем к нему zIndex и пробрасываем его как props
 * 3. Сохраняем новый zIndex в context
 */

function zIndexStack(initialZIndex) {
  return function (Target) {
    var _class, _temp;

    return _temp = _class = /*#__PURE__*/function (_Component) {
      (0, _inherits2.default)(_class, _Component);

      var _super = _createSuper(_class);

      function _class() {
        var _this;

        (0, _classCallCheck2.default)(this, _class);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _super.call.apply(_super, [this].concat(args));
        _this.zIndex = (_this.context.ruiZIndex || 0) + _this.props.zIndex;
        return _this;
      }

      (0, _createClass2.default)(_class, [{
        key: "render",
        value: function render() {
          return _react.default.createElement(ZIndexStackContext.Provider, {
            value: this.contextValue
          }, _react.default.createElement(Target, (0, _extends2.default)({}, this.props, {
            zIndex: this.zIndex
          })));
        }
      }, {
        key: "contextValue",
        get: function get() {
          return {
            ruiZIndex: this.zIndex
          };
        }
      }]);
      return _class;
    }(_react.Component), _class.displayName = "zIndexStack(".concat((0, _getDisplayName.default)(Target), ")"), _class.propTypes = {
      zIndex: _propTypes.default.number
    }, _class.defaultProps = {
      zIndex: initialZIndex
    }, _class.contextType = ZIndexStackContext, _temp;
  };
}